// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2vc-o","name":"ConsentHeader_name__xFsuC","birthday":"ConsentHeader_birthday__1SNjD","skeleton":"ConsentHeader_skeleton__3eqeg"};